import { render, staticRenderFns } from "./hsiiItemEditDetails.vue?vue&type=template&id=49915f60"
import script from "./hsiiItemEditDetails.vue?vue&type=script&lang=js"
export * from "./hsiiItemEditDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports